import * as wjcCore from "@mescius/wijmo";

import {Injectable} from "@angular/core";
import {HttpClient, HttpContext} from "@angular/common/http";
import {ConfigService} from "@cosbeni/auth";
import {Observable} from "rxjs";

@Injectable()
export class DataService {

  constructor(private http: HttpClient, private config: ConfigService) {
  }

  /**
   * @param context interceptor へ渡す HttpContext (例: アプリ側のローディング表示を抑止する token)。
   *   OrientDBCollectionView は従来 3 番目の引数に tokenName (文字列) を渡してくるため、
   *   HttpContext 以外は無視する (渡すと HttpClient が context.get で例外になり全一覧が読めなくなる)。
   */
  query(object: Object, url?: string, context?: HttpContext | string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    const options: any = {body: object};
    if (context instanceof HttpContext) {
      options.context = context;
    }
    return this.http.request("POST", joinUrl(url, "/rest/data/query"), options);
  }

  update(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    object = this.removeInvalidLink(object);
    return this.http.request("POST", joinUrl(url, "/rest/data/update?mode=partial"), {body: object});
  }

  delete(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("POST", joinUrl(url, "/rest/data/delete"), {body: object});
  }

  command(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("POST", joinUrl(url, "/rest/data/command"), {body: object});
  }

  batch(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("POST", joinUrl(url, "/rest/data/batch"), {body: object});
  }

  graph(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("POST", joinUrl(url, "/rest/data/graph/update?mode=partial"), {body: object});
  }

  user(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("GET", joinUrl(url, "/rest/user"), {body: object});
  }

  file(object: any, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("GET", joinUrl(url, "/orecordbytes"), {params: object, responseType: "blob"});
  }

  post(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("POST", url, {body: object});
  }

  get(object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("GET", url, {body: object});
  }

  getBlob(object: any, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("GET", url, {params: object, responseType: "blob"});
  }

  send(method: string, object: Object, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request(method, url, {body: object});
  }

  voicemessage(object: any, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("GET", joinUrl(url, "/voicemessage"), {params: object, responseType: "blob"});
  }

  monitor(object: any, url?: string): Observable<any> {
    if (url == null) {
      url = this.config.options.serverUrl;
    }
    return this.http.request("GET", joinUrl(url, "/monitor"), {params: object, responseType: "blob"});
  }

  processLink(object: Object) {
    const keys: any[] = Object.keys(object);
    keys.forEach((key: any) => {
      if (wjcCore.isObject(object[key]) && !wjcCore.isUndefined(object[key]["@rid"]) && !wjcCore.isNullOrWhiteSpace(object[key]["@rid"])) {
        object[key] = object[key]["@rid"];
      }
      if (wjcCore.isArray(object[key])) {
        const children: any[] = [];
        for (const subentity of object[key]) {
          if (!wjcCore.isUndefined(subentity["@rid"]) && !wjcCore.isNullOrWhiteSpace(subentity["@rid"])) {
            children.push(subentity["@rid"]);
          } else {
            children.push(subentity);
          }
        }
        object[key] = children;
      }
    });
    return object;
  }

  removeInvalidLink(object: Object) {
    const keys: any[] = Object.keys(object);
    keys.forEach((key: any) => {
      if (wjcCore.isObject(object[key])) {
        object[key] = this.removeInvalidLink(object[key]);
      }
      if (wjcCore.isString(object[key]) && object[key] === "#-1:-1") {
        delete object[key];
      }
      if (wjcCore.isArray(object[key])) {
        const children: any[] = [];
        for (let subEntity of object[key]) {
          if (wjcCore.isObject(subEntity)) {
            subEntity = this.removeInvalidLink(subEntity);
          }
          if (!wjcCore.isString(subEntity) || subEntity !== "#-1:-1") {
            children.push(subEntity);
          }
        }
        object[key] = children;
      }
    });
    return object;
  }

}

export function joinUrl(baseUrl: string, url: string) {
  if (/^(?:[a-z]+:)?\/\//i.test(url)) {
    return url;
  }

  const joined = [baseUrl, url].join("/");

  const normalize = function (str: string) {
    return str
      .replace(/\/+/g, "/")
      .replace(/\/\?/g, "?")
      .replace(/\/#/g, "#")
      .replace(/:\//g, "://");
  };

  return normalize(joined);
}



